import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { fetchData } from "./config";
import { ErrorType } from "./errorType";
import packageInfo from "../../package.json";
interface campaign {
  id: string;
  name: string;
  id_encrypted: string;

  pin_logo: string;
}

interface campaignState {
  list: [];
  allCampaigns: campaign[];
  status: string;
  errorMessage: string;
  errorType: ErrorType | null;
  detail: {
    name: string;
    link: string;
    short_link: string;
    link_qr_svg: string;
    link_qr_pdf: string;
    link_qr_pdf_bw: string;
    link_qr_png: string | null;
    link_qr_png_bw: string | null;
    code: string;
    brand: string;
    email_signature: string[];
    email_template: {
      en: string;
      es: string;
    };
    social_post_auto_1: string;
    social_post_auto_2: string;
    social_post_auto_3: string;
    social_post_auto_4: string;
    social_post_auto_5: string;
  };
}

interface MyKnownError {
  errorMessage: string;
  errorCode: string;
}

const initialState: campaignState = {
  list: [],
  allCampaigns: [],
  status: "",
  errorMessage: "string",
  errorType: null,
  detail: {
    name: "",
    link: "",
    short_link: "",
    link_qr_svg: "",
    link_qr_pdf: "",
    link_qr_pdf_bw: "",
    link_qr_png: "",
    link_qr_png_bw: "",
    code: "",
    brand: "",
    email_signature: ["", ""],
    email_template: {
      en: "",
      es: "",
    },
    social_post_auto_1: "",
    social_post_auto_2: "",
    social_post_auto_3: "",
    social_post_auto_4: "",
    social_post_auto_5: "",
  },
};

export const getCampaigns = createAsyncThunk<
  any,
  undefined,
  { rejectValue: MyKnownError }
>("get/campaigns", async (_, thukApi) => {
  /* await thukApi.dispatch(refreshtoken()) */
  const response = await fetchData().get(
    `/api/purls/employee/campaigns?versionjs=${packageInfo.version}`
  );
  /*   const response = await fetchDataRefresh().get(`/api/purls/employee/campaigns?versionjs=${version}`) */
  const { data } = (await response).data;
  return data;
});

export const getAllCampaigns = createAsyncThunk<any>(
  "get/allCampaigns",
  async () => {
    const response = await fetchData().post(`/api/public/purls/brands`);

    const data = (await response).data;
    return data;
  }
);

interface DetailProp {
  id_campaign: string;
  id_employee: string;
}
export const getDetailCampaign = createAsyncThunk<any, DetailProp>(
  "get/detailCampaign",
  async ({ id_campaign, id_employee }, thukApi) => {
    /* await thukApi.dispatch(refreshtoken()) */
    const response = await fetchData().put(
      `/api/purls/employee/campaigns/links?versionjs=${packageInfo.version}`,
      { id_campaign, id_employee }
    );
    const { data } = (await response).data;

    const reponse_name = await fetchData().get(
      `/api/purls/employee/campaigns/${id_campaign}?versionjs=${packageInfo.version}`
    );
    const { data: data_c } = (await reponse_name).data;

    let {
      code,
      email_signature,
      brand: { code: brand_code },
      name,
    } = data_c;
    const data_res = { code, email_signature, brand_code, name, ...data };

    //console.log(data_res)

    return data_res;
  }
);

const campaignSlice = createSlice({
  name: "campaign",
  initialState,
  reducers: {
    setQRCodeImg: (state, { payload }) => {
      state.detail.link_qr_png = payload.img;
    },
    setQRCodeImgBw: (state, { payload }) => {
      state.detail.link_qr_png_bw = payload.img;
    },
  },
  extraReducers: (builder) => {
    /* Login step one */
    builder.addCase(getCampaigns.pending, (state) => {
      state.status = "getCampaigns_loading";
    });
    builder.addCase(getCampaigns.fulfilled, (state, { payload }) => {
      state.list = payload;
      state.status = "getCampaigns_success";
    });
    builder.addCase(getCampaigns.rejected, (state, { error }) => {
      if (
        error.message === "Request failed with status code 404" ||
        error.message === "Network Error"
      ) {
        state.errorMessage =
          "The server is not responding check your internet connection";
        state.errorType = ErrorType.ERROR_SERVER;
      }
      if (error.message === "Request failed with status code 422") {
        state.errorMessage =
          "You do not have a campaign assigned, contact your system administrators.";
        state.errorType = ErrorType.ERROR_PERMISSION;
      }
      state.status = "getCampaigns_rejected";
    });
    builder.addCase(getAllCampaigns.pending, (state) => {
      state.status = "getAllCampaigns_loading";
    });
    builder.addCase(getAllCampaigns.fulfilled, (state, { payload }) => {
      state.allCampaigns = payload.data;
      state.status = "getAllCampaigns_success";
    });
    builder.addCase(getAllCampaigns.rejected, (state, { error }) => {
      if (
        error.message === "Request failed with status code 404" ||
        error.message === "Network Error"
      ) {
        state.errorMessage =
          "The server is not responding check your internet connection";
        state.errorType = ErrorType.ERROR_SERVER;
      }
      state.status = "getCampaigns_rejected";
    });
    builder.addCase(getDetailCampaign.pending, (state) => {
      state.status = "getDetailCampaign_loading";
    });
    builder.addCase(getDetailCampaign.fulfilled, (state, { payload }) => {
      state.detail.name = payload.name;
      state.detail.link = payload.link;
      state.detail.short_link = payload.short_link;
      state.detail.link_qr_svg = payload.link_qr_svg;
      state.detail.link_qr_pdf = payload.link_qr_pdf;
      state.detail.link_qr_pdf_bw = payload.link_qr_pdf_bw;
      state.detail.link_qr_png = payload.link_qr_png;
      state.detail.link_qr_png_bw = payload.link_qr_png_bw;
      /*       state.detail.link_qr_png= null
      state.detail.link_qr_png_bw = null */
      state.detail.code = payload.code;
      state.detail.email_signature = payload.email_signature;
      state.detail.brand = payload.brand_code;
      state.detail.email_template.en = payload.email_template.en;
      state.detail.email_template.es = payload.email_template.es;
      state.detail.social_post_auto_1 = payload.social_post_auto_1;
      state.detail.social_post_auto_2 = payload.social_post_auto_2;
      state.detail.social_post_auto_3 = payload.social_post_auto_3;
      state.detail.social_post_auto_4 = payload.social_post_auto_4;
      state.detail.social_post_auto_5 = payload.social_post_auto_5;
      state.status = "getDetailCampaign_success";
    });
    builder.addCase(getDetailCampaign.rejected, (state, { error }) => {
      if (
        error.message === "Request failed with status code 422" ||
        error.message === "Network Error"
      ) {
        state.errorMessage =
          "The server is not responding check your internet connection";
        state.errorType = ErrorType.ERROR_SERVER;
      } else {
        state.errorMessage = "The entered campaign does not exist";
        state.errorType = ErrorType.ERROR_PERMISSION;
      }
      if (error.message === "Request failed with status code 422") {
        state.errorMessage = "The entered campaign does not exist";
        state.errorType = ErrorType.ERROR_PERMISSION;
      }
      state.status = "getDetailCampaign_rejected";
    });
  },
});

export default campaignSlice.reducer;

export const { setQRCodeImg, setQRCodeImgBw } = campaignSlice.actions;
